import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  ls,
  gs,
  cmPCD,
  useMsgz,
  BoxC,
  BtnC,
  BtnCttC,
  CbxC,
  IptC,
  LblC,
  GridC,
  TextC,
  _cv_31___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cmPCD from "./_cmPCD";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as icvI15___Mz from './icvI15___Mz';
import * as icvI16___Mz from './icvI16___Mz';
import * as icvI18___Mz from './icvI18___Mz';
import * as icvI18___EzP1 from './icvI18___EzP1';
import * as icvI18___EzP2 from './icvI18___EzP2';
import * as icvI18___EzP3 from './icvI18___EzP3';

let $i18z = icvI18___Mz.ilzI18z();

let $i15rs = [] as ht.ls; //団体種別
let $i15rz = {} as ht.dz; //団体種別
let $i16rs = [] as ht.ls; //ジャンル

let $_31rs = [] as ht.ls; //地区センター

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _b = await icvI18___Mz.chkI18zAsync({
            role: 's',
            i18z: $i18z,
            sMsgz: _sMsgz,
          });
          if (_b) {
            const _i18z = await icvI18___Mz.saveI18rDzAsync({
              ... pz,
              i18z: $i18z,
            });
            return {
              i18r_fst :_i18z.i18rz._fst,
            };
          }
        },
        dltAsync: async () => {
          hf.udtDz($i18z.i18rz, {
            _dlt: 1, // 削除
          });
          await icvI18___Mz.saveI18rDzAsync({
            ... pz,
            i18z: $i18z,
          });
        }
      }
    })
  );
};

export const F = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  return (
    cr.c(GridC.N, {
      key: -10,
      abtType: 'barBtnFtnCmnz',
      boxStlz: a('dw/120 mb/2'),
      lineCs: [
        {
          cellCs: [
            {
              oClds: [
              ]
            },
            {
              oClds: [
                cr.c(BtnC.N, {
                  key: -20,
                  abtType: 'ctdFtnStfz',
                  boxStlz: a('dw/25 mr/1'),
                  lblCz: {
                    textz: {
                      pfx: '初回ご登録の手引き(PDF)',
                    }
                  },
                  pslPtyz: {
                    onPress: () => {
//                      hf.l(`icvI18___Ci 168: ${hf.s(_gUserz.crt)}`);
                      if (_gUserz.crt.i19rz.i19ra1220i == 10) {
                        icvI18___EzP1.eptPdfAsync({
                          i18r_fst: pz.sPz.crt.i18r_fst,
                        })
                      }
                      if (_gUserz.crt.i19rz.i19ra1220i == 20) {
                        icvI18___EzP2.eptPdfAsync({
                          i18r_fst: pz.sPz.crt.i18r_fst,
                        })
                      }
                      if (_gUserz.crt.i19rz.i19ra1220i == 30) {
                        icvI18___EzP3.eptPdfAsync({
                          i18r_fst: pz.sPz.crt.i18r_fst,
                        })
                      }
                    }
                  }
                })
              ]
            },
            {
              oClds: [
              ]
            },
          ]
        }
      ]
    })
  );
}

export const D = (pz: ht.viewDtlCz) => {

//  const _udtThis = ls.frcUdt();
  const _gUserz = gs.useUserz();

  const _udtThis = ls.udtThis();

  React.useEffect( () => {
    cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _udtThis,
      bfrAsync: () => [
        _cv_31___Mz.load_31rLsAsync()
        .then((_ls: ht.ls) => {
          //hf.l(`IcvI18b 138: ${hf.s(_ls)}`);
          $_31rs = _ls;
        }),
        icvI16___Mz.loadI16rLsAsync()
        .then((_ls: ht.ls) => {
          //hf.l(`IcvI18b 138: ${hf.s(_ls)}`);
          $i16rs = _ls;
        }),
        icvI15___Mz.loadI15rLsAsync()
        .then((_ls: ht.ls) => {
          //hf.l(`IcvI18b 144: ${hf.s(_ls)}`);
          $i15rs = _ls;
        }),
      ],
      crtAsync: () => [
        icvI18___Mz.crtI18z()
        .then((_dz: ht.dz) => {
          hf.udtDz($i18z, _dz);
        })
      ],
      udtAsync: () => [
        icvI18___Mz.loadI18rDzAsync({
          i18r_fst: pz.sPz.crt.i18r_fst,
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
//          hf.l(`icvI18___Ci 149: ${pz.sPz.crt.i18r_fst}, ${hf.s(_dz)}`);
          hf.udtDz($i18z, _dz);
        })
      ]
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt.i18r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  //hf.l(`IcvI18b 79: ${hf.j(_gUserz.crt.i19rz.i19ra3100j)["110"] == 1}`);
  //hf.l(`IcvI18b 79: ${_gUserz.crt.i19rz.i19ra1220i}`);
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
        cr.c(TextC.N, {
          key: -10,
          abtType: 'rmkCmnz',
          boxStlz: a(`dw/f fd/rsc mb/1`),
          textz: {
            pfx: '※：必須'
          }
        })
        : null,

        cr.c(GridC.N, {
          key: -20,
          abtType: 'nolineCmnz',
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '施設',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              iptType: 'pcr',
                              ls: $_31rs,
                              vle: $i18z.i18rz.i18r_31r1f,
                              onChg: (_dz: ht.dz) => {
                                $i18z.i18rz.i18r_31r1f = _dz.key;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '団体種別',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              iptType: 'pcr',
                              ls: $i15rs,
                              vle: $i18z.i18rz.i18ri15r1f,
                              onChg: (_dz: ht.dz) => {
                                $i18z.i18rz.i18ri15r1f = _dz.key;
                                $i15rz = _dz;
                                if (_dz.i15ra1100i == -1) { // 利用料なし
                                  $i18z.i18rz.i18raa100i = 100;
                                  $i18z.i18rz.i18raa200i = 100;
                                  $i18z.i18rz.i18raa300i =  -1;
                                  _udtThis();
                                }
                                if (_dz.i15ra1100i ==  1) { // 利用料あり
                                  $i18z.i18rz.i18raa100i =  0;
                                  $i18z.i18rz.i18raa200i =  0;
                                  $i18z.i18rz.i18raa300i = -1;
                                  _udtThis();
                                }
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '団体番号',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: $i18z.i18rz.i18rab100s,
                            }
                          })
                        ],
                      },
/*
                      icvI1z___Mz: {
                        abtType: 'omtRqrCmnz',
                      }
*/
                    }),
                  ]
                },
                {
                  boxStlz: a(`fd/rsc`),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      textz: {
                        pfx: '★［団体番号］は登録時に自動生成されます',
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '団体かな',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              iptType: 'text',
                              vle: $i18z.i18rz.i18ra1100s,
                              onChg: (_s: ht.s) => {
                                $i18z.i18rz.i18ra1100s = _s;
                              },
                            }
                          })
                        ],
                      },
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {                        
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '団体名',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              iptType: 'text',
                              vle: $i18z.i18rz._pfx,
                              onChg: (_s: ht.s) => {
                                $i18z.i18rz._pfx = _s;
                              },
                            },
                            iptStlz: {
                              editz: a('dh/5 ts/4 pv/0.5')
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/3`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '代表者名',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              iptType: 'text',
                              vle: $i18z.i18rz.i18ra2110s,
                              onChg: (_s: ht.s) => {
                                $i18z.i18rz.i18ra2110s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '代表者かな',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              iptType: 'text',
                              vle: $i18z.i18rz.i18ra2120s,
                              onChg: (_s: ht.s) => {
                                $i18z.i18rz.i18ra2120s = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n pb/2 pl/1`),
              cellCs: [
                {
                  boxStlz: a(`fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
                      lblCz: {
                        textz: {
                          pfx: `WEB予約利用情報`,
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/csc`),
                        oClds: [

                          hf.i(_gUserz.crt.i19rz.i19ra1220i, [20]) ?
                          cr.c(LblC.N, {
                            key: -10,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: 'ログインID：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra4120s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra4120s = _s;
                                    },
                                  }
                                })
                              ],
                            },
/*
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : undefined,
*/
                          })
                          : undefined,

                          hf.i(_gUserz.crt.i19rz.i19ra1220i, [20, 30]) ?
                          cr.c(LblC.N, {
                            key: -20,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: 'パスワード：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    bScr: true,
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra4130s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra4130s = _s;
                                    },
                                  }
                                })
                              ],
                            },
/*
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : undefined,
*/
                          })
                          : undefined,

                          (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["110"] : -1) != 1 ?
                          cr.c(LblC.N, {
                            key: -30,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: 'メール１：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra4110s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra4110s = _s;
                                    },
                                  }
                                })
                              ],
                            },
/*
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : undefined,
*/
                          })
                          : null,
                          (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["120"] : -1) != 1 ?
                          cr.c(LblC.N, {
                            key: -40,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: 'メール２：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra4210s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra4210s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          })
                          : null,
                          (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["130"] : -1) != 1 ?
                          cr.c(LblC.N, {
                            key: -50,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: 'メール３：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
      //                              vle: 'user3@mail.com',
      //                              ls: spl.grps,
                                    vle: $i18z.i18rz.i18ra4310s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra4310s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          })
                          : null,

                        ]
                      }
                    }),
                  ]
                },
                {
                  boxStlz: a(`fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
//                      boxStlz: a(`fd/css`),
                      lblCz: {
                        textz: {
                          pfx: '連絡先',
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/csc`),
                        oClds: [

                          cr.c(LblC.N, {
                            key: -10,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '電話１：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra3510s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra3510s = _s;
                                    },
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                              (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["210"] : -1) == 1 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),

                          cr.c(LblC.N, {
                            key: -20,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '電話２：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra3520s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra3520s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          }),

                          (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["320"] : -1) != 1 ?
                          cr.c(LblC.N, {
                            key: -30,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '連絡先かな：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra2140s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra2140s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          })
                          : null,

                          (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["320"] : -1) != 1 ?
                          cr.c(LblC.N, {
                            key: -40,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '連絡先名：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra2130s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra2130s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          })
                          : null,

                          cr.c(TextC.N, {
                            key: -50,
                            textz: {
                              pfx: '★［電話１］は、日中に繋がりやすい番号を登録してください。★代表者と連絡先が同じ場合は、連絡先名は不要です。'
                            }
                          })

                        ]
                      }
                    }),
                  ]
                },
                {
                  boxStlz: a(`fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
//                      boxStlz: a(`fd/css`),
                      lblCz: {
                        textz: {
                          pfx: '所在地',
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/csc`),
                        oClds: [
                          cr.c(LblC.N, {
                            key: -10,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              abtType: 'hzlStfz',
                              textz: {
                                pfx: '郵便番号：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra3100s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra3100s = _s;
                                    },
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                              (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["110"] : -1) == 1 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),
                          hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                          cr.c(BtnC.N, {
                            key: -20,
//                            abtType: 'stfNmlz',
                            abtType: 'ctdFtnStfz',
                            boxStlz: a('mb/1'),
                            lblCz: {
                              textz: {
                                pfx: '住所を検索',
                              }
                            },
                            pslPtyz: {
                              onPress: async () => {
                                const _dz = await cmPCD.getArsAsync($i18z.i18rz.i18ra3100s);
                                if (_dz) {
                                  $i18z.i18rz.i18ra3200s = _dz.ars1;                                  
                                  $i18z.i18rz.i18ra3300s = _dz.ars2 + _dz.ars3 + _dz.ars4;                                  
                                  _udtThis();
                                }
//hf.l(`icvI18___Ci 814: ${hf.s(_dz)}`);
                              },
                            }
                          })
                          : undefined,
                          cr.c(LblC.N, {
                            key: -30,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              abtType: 'hzlStfz',
                              textz: {
                                pfx: '都道府県：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra3200s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra3200s = _s;
                                    },
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                              (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["120"] : -1) == 1 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),
                          cr.c(LblC.N, {
                            key: -40,
                            abtType: 'hzlMplStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '市町番地：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  iptStlz: {
                                    editz: a(`dh/8`),
                                    showz: a(`dh/8`)
                                  },
                                  iptPtyz: a(`tm`),
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra3300s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra3300s = _s;
                                    },
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                              (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["130"] : -1) == 1 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),
                          cr.c(LblC.N, {
                            key: -50,
                            abtType: 'hzlMplStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '建物名・フロア等：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  iptStlz: {
                                    editz: a(`dh/8`),
                                    showz: a(`dh/8`),
                                  },
                                  iptPtyz: a(`tm`),
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra3400s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra3400s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          }),
                        ]
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n pb/2 pl/1`),
              cellCs: [
                {
                  boxStlz: a(`f/2 fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
                      lblCz: {
                        textz: {
                          pfx: `減免`,
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/csc`),
                        oClds: [

                          cr.c(LblC.N, {
                            key: -10,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              textz: {
                                pfx: '減免率：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(CbxC.MS, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    ls: ihd.f(`i18raa100i`).ls,
                                    vle: $i18z.i18rz.i18raa100i,
                                    onChg: (_key: ht.n) => {
                                      $i18z.i18rz.i18raa100i = _key;
                                      if ( $i18z.i18rz.i18raa100i == -1 ){
                                        $i18z.i18rz.i18raa200i =  0;
                                        $i18z.i18rz.i18raa300i = -1;
                                        _udtThis();
                                      }
                                      if ( $i18z.i18rz.i18raa100i > 0 && $i18z.i18rz.i18raa100i <= 100 ){
                                        $i18z.i18rz.i18raa200i = $i18z.i18rz.i18raa100i
                                        _udtThis();
                                      }
                                      if ( $i18z.i18rz.i18raa100i > 100 ){
                                        $i18z.i18rz.i18raa200i = 0
                                        _udtThis();
                                      }
                                    },
                                  }
                                }),
                                cr.c(IptC.S, {
                                  key: -20,
                                  boxStlz: a(`dw/8`),
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) && $i18z.i18rz.i18raa100i == 999,
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18raa200i,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18raa200i = _s;
                                    },
                                  }
                                }),
                                cr.c(TextC.N, {
                                  key: -30,
                                  abtType: 'bsdCmnz',
                                  textz: {
                                    pfx: '%',
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) && $i18z.i18rz.i18raa100i == 999 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),

                          cr.c(LblC.N, {
                            key: -20,
                            abtType: 'hzlStfz',
                            lblCz: {
                              textz: {
                                pfx: `減免理由：`,
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) && $i18z.i18rz.i18raa100i > 0,
                                    iptType: 'pcr',
                                    ls: ihd.f(`i18raa300i`).ls,
                                    vle: $i18z.i18rz.i18raa300i,
                                    onChg: (_dz: ht.dz) => {
                                      $i18z.i18rz.i18raa300i = _dz.key;
                                    },
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) && $i18z.i18rz.i18raa100i > 0 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),

                        ]
                      }
                    }),
                  ]
                },
                {
                  boxStlz: a(`fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
                      lblCz: {
                        textz: {
                          pfx: `利用制限`,
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/csc`),
                        oClds: [
                          cr.c(CbxC.SS, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                              vle: $i18z.i18rz.i18rt1100i,
                              onChg: (_n: ht.n) => {
                                $i18z.i18rz.i18rt1100i = _n;
                              },
                            },
                            lblCz: {
                              textz: {
                                pfx: 'Web予約・エントリー利用を制限する',
                              }
                            }
                          })
                        ]
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n pb/2 pl/1`),
              cellCs: [
                {
                  boxStlz: a(`f/2 fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
                      lblCz: {
                        textz: {
                          pfx: `活動`,
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/rss`),
                        oClds: [

                          cr.c(BoxC.N, {
                            key: -10,
                            boxStlz: a(`f/1 fd/css`),
                            oClds: [
                              cr.c(LblC.N, {
                                key: -10,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: 'ジャンル：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'pcr',
                                        ls: $i16rs,
                                        vle: $i18z.i18rz.i18ri16r1f,
                                        onChg: (_dz: ht.dz) => {
                                          $i18z.i18rz.i18ri16r1f = _dz.key;
                                        },
                                      }
                                    })
                                  ],
                                },
                                omtCz: 
                                  hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                                  (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["110"] : -1) == 1 ?
                                  {
                                    abtType: 'omtRqrCmnz',
                                  }
                                  : null
                              }),
                              cr.c(LblC.N, {
                                key: -20,
                                abtType: 'hzlMplStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '活動内容：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      iptStlz: {
                                        editz: a(`dh/8`),
                                        showz: a(`dh/8`),
                                      },
                                      iptPtyz: a(`tm`),
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'text',
                                        vle: $i18z.i18rz.i18ra6100s,
                                        onChg: (_s: ht.s) => {
                                          $i18z.i18rz.i18ra6100s = _s;
                                        },
                                      }
                                    })
                                  ],
                                },
                                omtCz: 
                                  hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                                  (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["110"] : -1) == 1 ?
                                  {
                                    abtType: 'omtRqrCmnz',
                                  }
                                  : null
                              }),
                              cr.c(LblC.N, {
                                key: -30,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '会費：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      iptStlz: {
                                        editz: a(`dw/7 f/n`),
                                        showz: a(`dw/7 f/n`),
                                      },
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'pcr',
                                        ls: ihd.f(`i18ra8100i`).ls,
                                        vle: $i18z.i18rz.i18ra8100i,
                                        onChg: (_dz: ht.dz) => {
                                          $i18z.i18rz.i18ra8100i = _dz.key;
                                        },
                                      }
                                    }),
                                    cr.c(IptC.S, {
                                      key: -20,
                                      iptStlz: {
                                        editz: a(`ta/r`),
                                        showz: a(`ta/r`),
                                      },
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'text',
                                        vle: $i18z.i18rz.i18ra8200i,
                                        onChg: (_s: ht.s) => {
                                          $i18z.i18rz.i18ra8200i = _s;
                                        },
                                      }
                                    }),
                                    cr.c(TextC.N, {
                                      key: -30,
                                      abtType: 'bsdCmnz',
                                      textz: {
                                        pfx: '円',
                                      },
                                    }),
                                  ],
                                }
                              }),

                            ]
                          }),

                          cr.c(BoxC.N, {
                            key: -20,
                            boxStlz: a(`f/1 fd/css`),
                            oClds: [

                              cr.c(LblC.N, {
                                key: -10,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '活動頻度：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      iptStlz: {
                                        editz: a(`dw/7 f/n`),
                                        showz: a(`dw/7 f/n`),
                                      },
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'pcr',
                                        ls: ihd.f(`i18ra6310i`).ls,
                                        vle: $i18z.i18rz.i18ra6310i,
                                        onChg: (_dz: ht.dz) => {
                                          $i18z.i18rz.i18ra6310i = _dz.key;
                                        },
                                      }
                                    }),
                                    cr.c(IptC.S, {
                                      key: -20,
                                      iptStlz: {
                                        editz: a(`ta/r`),
                                        showz: a(`ta/r`),
                                      },
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'text',
                                        vle: $i18z.i18rz.i18ra6320i,
                                        onChg: (_s: ht.s) => {
                                          $i18z.i18rz.i18ra6320i = _s;
                                        },
                                      }
                                    }),
                                    cr.c(TextC.N, {
                                      key: -30,
                                      abtType: 'bsdCmnz',
                                      textz: {
                                        pfx: '回',
                                      },
                                    })
                                  ],
                                }
                              }),

                              cr.c(LblC.N, {
                                key: -20,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '時間帯：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'pcr',
                                        ls: ihd.f(`i18ra6400i`).ls,
                                        vle: $i18z.i18rz.i18ra6400i,
                                        onChg: (_dz: ht.dz) => {
                                          $i18z.i18rz.i18ra6400i = _dz.key;
                                        },
                                      }
                                    })
                                  ],
                                }
                              }),

                              cr.c(LblC.N, {
                                key: -30,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '曜日：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'text',
                                        vle: $i18z.i18rz.i18ra6500s,
                                        onChg: (_s: ht.s) => {
                                          $i18z.i18rz.i18ra6500s = _s;
                                        },
                                      }
                                    })
                                  ],
                                }
                              }),

                              (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["310"] : -1) != 1 ?
                              cr.c(LblC.N, {
                                key: -40,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '指導者かな：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'text',
                                        vle: $i18z.i18rz.i18ra9120s,
                                        onChg: (_s: ht.s) => {
                                          $i18z.i18rz.i18ra9120s = _s;
                                        },
                                      }
                                    })
                                  ],
                                }
                              })
                              : null,

                              (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["310"] : -1) != 1 ?
                              cr.c(LblC.N, {
                                key: -50,
                                abtType: 'hzlStfz',
                                boxStlz: a(`mb/1`),
                                lblCz: {
                                  textz: {
                                    pfx: '指導者名：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                        iptType: 'text',
                                        vle: $i18z.i18rz.i18ra9110s,
                                        onChg: (_s: ht.s) => {
                                          $i18z.i18rz.i18ra9110s = _s;
                                        },
                                      }
                                    })
                                  ],
                                }
                              })
                              : null,

                            ]
                          }),

                        ]
                      }
                    }),
                  ]
                },
                {
                  boxStlz: a(`fd/css pr/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'bandCtrStfz',
                      lblCz: {
                        textz: {
                          pfx: `会員・備考`,
                          stlz: a(`tc/lt1`),
                        }
                      },
                      cttCz: {
                        boxStlz: a(`fd/csc`),
                        oClds: [

                          cr.c(LblC.N, {
                            key: -10,
                            abtType: 'hzlMplStfz',
                            boxStlz: a('mb/0.5'),
                            lblCz: {
                              boxStlz: a(`dw/8`),
                              textz: {
                                pfx: '内訳：',
                              }
                            },
                            cttCz: {
                              boxStlz: a(`fd/css`),
                              oClds: [

                                (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["210"] : -1) != 1 ?
                                cr.c(LblC.N, {
                                  key: -10,
                                  abtType: 'hzlStfz',
                                  boxStlz: a('mb/0.5'),
                                  lblCz: {
                                    boxStlz: a('dw/8'),
                                    textz: {
                                      pfx: '男性',
                                      stlz: a(`tb/n tc/lt9`)
                                    }
                                  },
                                  cttCz: {
                                    oClds: [
                                      cr.c(IptC.S, {
                                        key: -10,
                                        iptStlz: {
                                          editz: a(`ta/r`),
                                          showz: a(`ta/r`),
                                        },
                                        cz: {
                                          bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                          iptType: 'text',
                                          vle: $i18z.i18rz.i18ra7310i,
                                          onChg: (_s: ht.s) => {
                                            $i18z.i18rz.i18ra7310i = _s;
                                          },
                                        }
                                      }),
                                      cr.c(TextC.N, {
                                        key: -20,
                                        abtType: 'bsdCmnz',
                                        textz: {
                                          pfx: '人',
                                        },
                                      }),
                                    ],
                                  }
                                })
                                : null,

                                (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["220"] : -1) != 1 ?
                                cr.c(LblC.N, {
                                  key: -20,
                                  abtType: 'hzlStfz',
                                  boxStlz: a('mb/0.5'),
                                  lblCz: {
                                    boxStlz: a('dw/8'),
                                    textz: {
                                      pfx: '女性',
                                      stlz: a(`tb/n tc/lt9`)
                                    }
                                  },
                                  cttCz: {
                                    oClds: [
                                      cr.c(IptC.S, {
                                        key: -10,
                                        iptStlz: {
                                          editz: a(`ta/r`),
                                          showz: a(`ta/r`),
                                        },
                                        cz: {
                                          bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                          iptType: 'text',
                                          vle: $i18z.i18rz.i18ra7320i,
                                          onChg: (_s: ht.s) => {
                                            $i18z.i18rz.i18ra7320i = _s;
                                          },
                                        }
                                      }),
                                      cr.c(TextC.N, {
                                        key: -20,
                                        abtType: 'bsdCmnz',
                                        textz: {
                                          pfx: '人',
                                        },
                                      }),
                                    ],
                                  }
                                })
                                : null,

                                (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["230"] : -1) != 1 ?
                                cr.c(LblC.N, {
                                  key: -30,
                                  abtType: 'hzlStfz',
                                  boxStlz: a('mb/0.5'),
                                  lblCz: {
                                    boxStlz: a('dw/8'),
                                    textz: {
                                      pfx: '大人',
                                      stlz: a(`tb/n tc/lt9`)
                                    }
                                  },
                                  cttCz: {
                                    oClds: [
                                      cr.c(IptC.S, {
                                        key: -10,
                                        iptStlz: {
                                          editz: a(`ta/r`),
                                          showz: a(`ta/r`),
                                        },
                                        cz: {
                                          bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                          iptType: 'text',
                                          vle: $i18z.i18rz.i18ra7330i,
                                          onChg: (_s: ht.s) => {
                                            $i18z.i18rz.i18ra7330i = _s;
                                          },
                                        }
                                      }),
                                      cr.c(TextC.N, {
                                        key: -20,
                                        abtType: 'bsdCmnz',
                                        textz: {
                                          pfx: '人',
                                        },
                                      }),
                                    ],
                                  }
                                })
                                : null,

                                (hf.j(_gUserz.crt.i19rz.i19ra3100j) ? hf.j(_gUserz.crt.i19rz.i19ra3100j)["240"] : -1) != 1 ?
                                cr.c(LblC.N, {
                                  key: -40,
                                  abtType: 'hzlStfz',
                                  boxStlz: a('mb/0.5'),
                                  lblCz: {
                                    boxStlz: a('dw/8'),
                                    textz: {
                                      pfx: 'こども',
                                      stlz: a(`tb/n tc/lt9`)
                                    }
                                  },
                                  cttCz: {
                                    oClds: [
                                      cr.c(IptC.S, {
                                        key: -10,
                                        iptStlz: {
                                          editz: a(`ta/r`),
                                          showz: a(`ta/r`),
                                        },
                                        cz: {
                                          bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                          iptType: 'text',
                                          vle: $i18z.i18rz.i18ra7340i,
                                          onChg: (_s: ht.s) => {
                                            $i18z.i18rz.i18ra7340i = _s;
                                          },
                                        }
                                      }),
                                      cr.c(TextC.N, {
                                        key: -20,
                                        abtType: 'bsdCmnz',
                                        textz: {
                                          pfx: '人',
                                        },
                                      }),
                                    ],
                                  }
                                })
                                : null,

                              ],
                            }
                          }),

                          cr.c(LblC.N, {
                            key: -20,
                            abtType: 'hzlStfz',
                            boxStlz: a(`mb/1`),
                            lblCz: {
                              boxStlz: a(`dw/8`),
                              textz: {
                                pfx: '募集：',
                              }
                            },
                            cttCz: {
                              boxStlz: a(`dw/10`),
                              oClds: [
                                cr.c(CbxC.MS, {
                                  key: -10,
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    ls: ihd.f(`i18ra8300i`).ls,
                                    vle: $i18z.i18rz.i18ra8300i,
                                    onChg: (_n: ht.n) => {
                                      $i18z.i18rz.i18ra8300i = _n;
                                    },
                                  }
                                })
                              ],
                            },
                            omtCz: 
                              hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) &&
                              (hf.j(_gUserz.crt.i19rz.i19ra3200j) ? hf.j(_gUserz.crt.i19rz.i19ra3200j)["410"] : -1) == 1 ?
                              {
                                abtType: 'omtRqrCmnz',
                              }
                              : null
                          }),

                          cr.c(LblC.N, {
                            key: -30,
                            abtType: 'hzlStfz',
                            boxStlz: a(`fd/rss`),
                            lblCz: {
                              boxStlz: a(`dw/8`),
                              textz: {
                                pfx: '備考：',
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  iptStlz: {
                                    editz: a(`dh/8`),
                                    showz: a(`dh/8`),
                                  },
                                  iptPtyz: a(`tm`),
                                  cz: {
                                    bEdit: hf.i(pz.sPz.crt.phs, [`crt`, `udt`]),
                                    iptType: 'text',
                                    vle: $i18z.i18rz.i18ra6200s,
                                    onChg: (_s: ht.s) => {
                                      $i18z.i18rz.i18ra6200s = _s;
                                    },
                                  }
                                })
                              ],
                            }
                          }),

                        ]
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

      ]
    })
  );
};

